
import React from "react";
import { Typography, Button, Row, Col, Form, Input } from "antd";
import { UserOutlined } from "@ant-design/icons";
import LogoImg from "../../../assets/images/Logo2.svg";
// import LogoImg from "../../../assets/images/cultiva.png";
import BackArrowImg from "../../../assets/images/arrowLeft.png";
import BannerImg from "../../../assets/images/banner.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { forgotPasswordAction } from "../../../redux/reducer/AuthSlice";
import { urlConstant } from "../../../constants/urlConstant";

const { Title, Text } = Typography;

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { forgetLoading, forgetError, data, error  } = useSelector((state) => state.auth);


  const handleSubmit = async (values) => {
    const data = await dispatch(forgotPasswordAction({ email: values.email }))
    if(data?.payload?.code === 200 && data?.type === "auth/forgotPassword/fulfilled"){
      navigate(urlConstant?.VerifyOtp)
    }
  };

  return (
    <div className="signinContainer">
      <Row gutter={16} className="signin-row">
        <Col xs={24} sm={12}>
          <div className="leftSection cflex">
            <div className="leftContainer">
              <img src={LogoImg} alt="Logo" className="logo" />
              <Link to="/" className="backToLogin mt-3">
                <img src={BackArrowImg} alt="BackArrowImg" /> Back To Login
              </Link>
              <Title level={2}>Forgot Password?</Title>
              <Text className="subtitle mb-2">
                No worries, we’ll send you the reset instructions.
              </Text>
              <Form
                form={form}
                onFinish={handleSubmit}
                 requiredMark="optional"
                layout="vertical"
                className="signin-form"
              >
                <Form.Item
                  name="email"
                  label={<span>Email<span style={{ color: "red" }}>*</span></span>}
                  rules={[
                    { required: true, message: "Please enter your email" },
                    { type: "email", message: "Enter a valid email" },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Enter your email"
                    prefix={<UserOutlined />}
                  />
                </Form.Item>
               
                <Button
                  type="primary"
                  className="customButton mt-3"
                  htmlType="submit"
                  loading={forgetLoading}
                >
                  {forgetLoading ? "Loading..." : "Submit" }
                </Button>

                {error && <Text type="danger" className="mt-2">{error}</Text>}
                {data && (
                  <Text type="success" className="mt-2">
                    Check your email for a reset link!
                  </Text>
                )}

                <Text className="subtitle mt-5 text-center">© Cultivate 2025</Text>
              </Form>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <div className="rightSection cflex">
            <img src={BannerImg} alt="Banner" className="banner" />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ForgotPassword;
